/* eslint-disable @typescript-eslint/no-floating-promises, parog-web/no-glint-expect-error-directive */
import { on } from '@ember/modifier';
import type Owner from '@ember/owner';
import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';
import { runTask } from 'ember-lifeline';
import Content from 'parog-web/components/documents-retrieve-access-form/show/content';
import type DmpConsultationContext from 'parog-web/contexts/dmp-consultation-context';
import PageContainer from 'ui-kit/components/page-container';

interface Args {
  context: DmpConsultationContext;
}

export default class DocumentsRetrieveAccessFormShowComponent extends Component<Args> {
  @tracked isGoingBack = false;
  @tracked shouldShowHeaders = false;

  get title(): string {
    return `Consultation d'un document DMP${
      this.args.context.isSecretConnection
        ? ' - Connexion secrète en cours'
        : ''
    }`;
  }

  constructor(owner: Owner, args: Args) {
    super(owner, args);
    if (!this.args.context.currentDocumentContent) {
      runTask(this, () => {
        this.args.context.transitionTo();
      });
    }
  }

  displayHeaders = (): void => {
    this.shouldShowHeaders = true;
  };

  hideHeaders = (): void => {
    this.shouldShowHeaders = false;
  };

  returnToDocuments = async () => {
    this.isGoingBack = true;
    this.args.context.currentDocumentMetadata = undefined;
    this.args.context.currentDocumentContent = undefined;
    this.args.context.currentState =
      await this.args.context.calculateCurrentState();
  };

  <template>
    <PageContainer
      @title={{this.title}}
      @background='transparent'
      @dontUseTextWidthLimit={{true}}
    >
      <:headerWidget>
        <button
          type='button'
          class='ui button'
          data-test-go-back-to-documents
          {{on 'click' this.returnToDocuments}}
        >
          Retourner à la liste des documents
        </button>
        {{#if this.shouldShowHeaders}}
          <button
            type='button'
            class='ui button'
            data-test-hide-headers
            {{on 'click' this.hideHeaders}}
          >
            Cacher les en-têtes du document
          </button>
        {{else}}
          <button
            type='button'
            class='ui button'
            data-test-show-headers
            {{on 'click' this.displayHeaders}}
          >
            Voir les en-têtes du document
          </button>
        {{/if}}
      </:headerWidget>

      <:content>
        {{#if this.isGoingBack}}
          <div class='ui segment'>
            <div class='ui active inverted dimmer'>
              <div class='ui text loader'>Retour à la liste des documents en
                cours...</div>
            </div>
          </div>
        {{else}}
          <Content
            @patient={{@context.patient}}
            {{! @glint-expect-error }}
            @metadata={{@context.currentDocumentMetadata}}
            @isRunning={{@context.isLoading}}
            {{! @glint-expect-error }}
            @content={{@context.currentDocumentContent}}
            @showHeaders={{this.shouldShowHeaders}}
            @returnToDocuments={{this.returnToDocuments}}
          />
        {{/if}}
      </:content>
    </PageContainer>
  </template>
}
